module.exports = __webpack_public_path__ + "static/media/dollar.d2812fa7.jpg";